import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

export const defaultContainerVariants = tv({
    base: "border-[0.5px] border-white/15",
    variants: {
        theme: {
            outer: `bg-black/75 backdrop-blur-2xl`,
            inner: `bg-black/35`,
            white: "bg-white",
            sharescreen:
                "bg-white emboss-shadow border-[1px] border-secondary-500 bg-gradient-to-b from-[#ECE7EC] to-white",
        },
        rounded: {
            sm: "rounded-lg",
            md: "rounded-2xl",
            default: "rounded-4xl",
        },
        shadow: {
            true: "shadow-overlay",
            false: "",
        },
    },
    defaultVariants: {
        theme: "outer",
        rounded: "default",
        shadow: true,
    },
});

export type DefaultContainerVariantProps = VariantProps<typeof defaultContainerVariants>;
